<div class="modal d-block" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg">
        <div class="modal-header bg-dark text-white p-2 px-3">
          <div class="d-flex align-items-center gap-2">
            <i class="bi bi-clock-history"></i>
            <h6 class="modal-title text-sm fw-bold">Answer History</h6>
          </div>
          <button type="button" class="btn-close btn-close-white" @click="$emit('close')"></button>
        </div>
        <div class="modal-body p-4 overflow-auto">
          <p v-if="question" class="text-xs fw-bold border-bottom pb-2 mb-3">
            Question: {{ question.question_text }}
          </p>

          <div v-if="loading" class="text-center py-5">
            <div class="spinner-border text-primary spinner-border-sm" role="status"></div>
            <p class="text-xxs mt-2">Loading history...</p>
          </div>

          <div v-else-if="history_loading" class="text-center py-5">
            <div class="spinner-border text-primary spinner-border-sm" role="status"></div>
            <p class="text-xxs mt-2">Loading history...</p>
          </div>

          <div v-else-if="!history_data || !history_data.length" class="text-center py-5">
            <p class="text-muted">No history found for this answer.</p>
          </div>

          <div v-else class="history-timeline">
            <div
              v-for="item in history_data"
              :key="item.id"
              class="history-item mb-4 border-start border-3 ps-3"
              :class="get_badge_class(item.status)"
            >
              <div class="d-flex justify-content-between align-items-start mb-1">
                <span class="text-xxs fw-bold text-dark">
                   Version {{ item.version }} - Submitted by: {{ item.user_first_name }} {{item.user_last_name}}
                </span>
                <span class="text-xxs text-muted">{{ format_datetime(item.date_answered) }}</span>
              </div>
              <!-- Show Preview button for file / facial_verification answers -->
              <div v-if="item.question_type_raw && ['file','facial_verification'].includes(item.question_type_raw)" class="mb-2">
                <div class="d-flex align-items-center gap-2">
                  <span class="text-xxs text-muted fw-6">{{ get_file_name_from_url(item.answer) }}</span>
                  <button class="btn btn-outline-primary btn-xs text-xxxs p-1" @click="open_file_preview(item.answer, get_file_name_from_url(item.answer))">Preview</button>
                </div>
              </div>
              <div v-else class="text-xs text-muted mb-2 fst-italic">
                "{{ item.answer }}"
              </div>

              <!-- Verifications for this version -->
              <div v-if="item.verifications && item.verifications.length" class="verifications-list bg-light p-2 rounded">
                 <p class="text-xxxs fw-bold text-muted border-bottom mb-1 pb-1">Verifications</p>
                 <div v-for="v in item.verifications" :key="v.id" class="verification-entry mb-1">
                    <div class="d-flex align-items-center gap-2">
                       <span class="status-pill text-xxxs" :class="get_badge_class(v.status)">
                         {{ get_label(v.status) }}
                       </span>
                       <span class="text-xxxs text-dark fw-6">{{ v.reviewer_name }}</span>
                       <span class="text-xxxs text-muted ms-auto">{{ format_datetime(v.date_created) }}</span>
                    </div>
                    <p v-if="v.note" class="text-xxxs text-muted mb-0 mt-1 ms-4 border-start ps-2">"{{ v.note }}"</p>
                 </div>
              </div>
            </div>
          </div>

          <!-- File preview modal (keeps paginator intact) -->
          <FilePreviewComponent
            v-if="show_file_preview"
            :presigned_url="preview_file_url"
            :file_name="preview_file_name"
            @close="close_file_preview"
            :key="preview_file_url"
          />

          <!-- Pagination -->
          <nav v-if="history_total_pages > 1" class="mt-4">
            <ul class="pagination pagination-sm justify-content-center m-0">
              <li class="page-item" :class="{ disabled: history_page === 1 }">
                <a class="page-link shadow-none" href="#" @click.prevent="change_page(history_page - 1)">Previous</a>
              </li>
              <li v-for="p in history_total_pages" :key="p" class="page-item" :class="{ active: history_page === p }">
                <a class="page-link shadow-none" href="#" @click.prevent="change_page(p)">{{ p }}</a>
              </li>
              <li class="page-item" :class="{ disabled: history_page === history_total_pages }">
                <a class="page-link shadow-none" href="#" @click.prevent="change_page(history_page + 1)">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
